import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EaiChatModule } from '@corvus-it-poland/eai-chat';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MarkdownModule } from 'ngx-markdown';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { environment } from '../environments/environment';
import { TuiRoot } from '@taiga-ui/core';
import { EventPluginsModule } from '@tinkoff/ng-event-plugins';
import { NG_EVENT_PLUGINS } from '@taiga-ui/event-plugins';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslocoRootModule } from './transloco-root.module';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';

registerLocaleData(localePl);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    EaiChatModule.forRoot({
      enabled: true,
      apiUrl: 'https://api.quick-ai.corvus-it.com',
      cmsUrl: 'https://cms.stable.quick-ai.corvus-it.com',
      socketUrl: 'wss://api.quick-ai.corvus-it.com',
      localStoragePrefix: 'eai-chat',
      markdownEditorUrl: environment.markdownEditorUrl,
      env: '',
      iFrameMode: true,
      provider: '',
    }),
    MarkdownModule.forRoot(),
    StoreModule.forRoot(),
    EffectsModule.forRoot(),
    TuiRoot,
    EventPluginsModule,
    TranslocoModule,
    TranslocoRootModule,
  ],
  providers: [NG_EVENT_PLUGINS, provideAnimationsAsync()],
  bootstrap: [AppComponent],
})
export class AppModule {}
